/**
 * React Query hooks for forecast operations.
 *
 * Both short-term and long-term forecasts are mutations (POST requests),
 * not queries, because results depend on user-supplied parameters.
 */

import { useMutation } from '@tanstack/react-query';
import { forecastAPI } from '../api/forecast';

/**
 * Mutation hook for short-term (day-ahead hourly) forecasting.
 * POST /v1/forecast/short-term
 */
export const useShortTermForecast = () => {
  return useMutation({
    mutationFn: (params) => forecastAPI.shortTerm(params),
  });
};

/**
 * Mutation hook for long-term (monthly SARIMA) forecasting.
 * POST /v1/forecast/long-term
 */
export const useLongTermForecast = () => {
  return useMutation({
    mutationFn: (params) => forecastAPI.longTerm(params),
  });
};

/**
 * Mutation hook for validating forecast against actual measured data.
 * POST /v1/forecast/validate
 */
export const useValidateForecast = () => {
  return useMutation({
    mutationFn: (params) => forecastAPI.validate(params),
  });
};
